// extracted by mini-css-extract-plugin
export default {"tip":"ModalImport_tip__Jm6UW","template":"ModalImport_template__e7jID"};